import { DatePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  OrderDetailsService,
  OrderDetailTotalsComponent,
  OrderOverviewComponent,
} from "@spartacus/order/components";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { RoutingService, TranslatePipe } from "@spartacus/core";
import { Observable, Subscription } from "rxjs";
import { Router } from "@angular/router";
import { formatTwoDecimals } from "src/constants/commonUtils";
import { CwtSpinnerComponent } from "../../common/cwt-spinner/cwt-spinner.component";

@Component({
    selector: "cx-order-confirmation-overview",
    templateUrl: "./kn-br-order-confirmation-overview.component.html",
    styleUrls: ["./kn-br-order-overview.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatePipe],
    imports: [
        CwtSpinnerComponent,
        DatePipe,
        TranslatePipe,
    ],
})
export class KnBrOrderConfirmationOverviewComponent
  extends OrderDetailTotalsComponent
  implements OnInit
{
  isOrderConfirmation: boolean = false;
  orderConfirmationData$: Observable<any>;
  order: any;
  allSubscriptions: Subscription;
  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected KnBrCheckoutService: KnBrCheckoutService,
    protected routingService: RoutingService,
    protected router: Router,
    protected cdr: ChangeDetectorRef
  ) {
    super(orderDetailsService);
    this.KnBrCheckoutService.setOrderConfirmationFlag(true);
  }

  ngOnInit() {
    this.getcurrentURL();
    super.ngOnInit();
    this.allSubscriptions = this.KnBrCheckoutService.order$.subscribe(
      (orderData) => {
        if (orderData) {
          this.order = orderData;
          this.cdr.detectChanges();
        } else {
          this.router.navigate(["/"]);
        }
      }
    );
  }

  getcurrentURL() {
    const currentURL = window.location.href;
    if (currentURL.includes("confirmation_pickup"))
      this.isOrderConfirmation = true;
  }

  navigate(url: string) {
    this.routingService.goByUrl(url);
  }
  formatPhone(raw: string): string {
    const digits = raw?.replace(/\D/g, "").slice(0, 10);
    if (digits?.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return raw;
  }

  maskCardNumber(cardNumber: string): string {
    if (!cardNumber) return "";
    const visible = this.extractMiddleDigits(cardNumber)
    return '**** **** ****' + " " + visible;
  }

  extractMiddleDigits(str) {
    const match = str.match(/-(\d+)-/);
    return match ? match[1] : null;
  }

  navigateToPlp() {
    this.KnBrCheckoutService.isCheckout$.next(false);
    this.router.navigate(["/search/active-brands"]);
  }

  formatPrice(priceValue) {
    return formatTwoDecimals(priceValue);
  }

  ngOnDestroy() {
    // super.ngOnDestroy();
    this.KnBrCheckoutService.setOrderConfirmationFlag(false);
    window.localStorage.removeItem("kn-br-cart-context");
    this.allSubscriptions?.unsubscribe();
    this.KnBrCheckoutService.clearOrder();
  }
}
